import { newToolFilterOAuthMcp } from "../oauth.ts";

export const motherduckMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://motherduck.com/apple-touch-icon.png",
  url: "https://api.motherduck.com/mcp",
  label: "MotherDuck",
});
